import { FC } from 'react';

import {
  Button,
  Card,
  Icon,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { Column } from 'src/components/Column/Column';
import { TooltipWrapper } from 'src/components/TooltipWrapper/TooltipWrapper';
import { Truncate } from 'src/components/Truncate/Truncate';

import { SpaceCardComponentProps } from '../types';

import classes from './DesktopSpaceCard.module.scss';
import { desktopSpaceCardStyle } from './consts';

export const DesktopSpaceCard: FC<SpaceCardComponentProps> = ({
  title,
  org,
  desksCount,
  onOpen,
  onDelete,
  disabled,
}) => {
  return (
    <Card
      border='default'
      className={classes.card}
      style={desktopSpaceCardStyle}
      onClick={onOpen}
    >
      <div className={classes.container}>
        <div className={classes.columns}>
          <Column
            title='Название'
            content={<Truncate variant='body3'>{title}</Truncate>}
            className={classes.title}
            testId='spaceTitle'
          />
          <Column
            title='Места'
            content={<Truncate variant='body3'>{desksCount}</Truncate>}
            className={classes.desksCount}
            testId='spaceDesksCount'
          />
          <Column
            title='Подразделение'
            content={<Truncate variant='body3'>{org}</Truncate>}
            className={classes.department}
            testId='spaceDepartment'
          />
        </div>

        <TooltipWrapper title='Удалить'>
          <Button
            size='medium'
            startIcon={<Icon iconName={Icons.Delete} />}
            onClick={onDelete}
            data-testid='deleteSpace'
            disabled={disabled}
          />
        </TooltipWrapper>
      </div>
    </Card>
  );
};
